import React, { useState, useEffect } from "react";
import Navigation from "../components/Navigation";
import Diaporama from "../components/Diaporama";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import expositionImg from "../assets/img/exposition.webp";

const Home = () => {
  const [slides, setSlides] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}getSlides.php`,
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setSlides(data);
      } catch (error) {
        console.error("Error fetching slides:", error);
      }
    };

    fetchSlides();
  }, []);

  return (
    <div>
      <Navigation />
      <Helmet>
        <title>Elize Sokolova | Contemporary Artist</title>
        <link
          rel="canonical"
          href={`https://www.elizesokolova.com${location.pathname}`}
        />
      </Helmet>
      <div className="wrapper">
        {/*<div className="home-diapo-container">
          <Diaporama images={slides} interval={3000} />
        </div>*/}
        <div className="exposition-img">
          <img src={expositionImg} alt="Exposition"></img>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;

/*
import React, { useState, useEffect } from "react";
import Navigation from "../components/Navigation";
import Diaporama from "../components/Diaporama";
import Footer from "../components/Footer";

const Home = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}getSlides.php`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setSlides(data);
      } catch (error) {
        console.error("Error fetching slides:", error);
      }
    };

    fetchSlides();
  }, []);

  return (
    <div>
      <Navigation />
      <div className="wrapper">
        <div className="home-diapo-container">
          <Diaporama images={slides} interval={3000} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
*/
